import { render, staticRenderFns } from "./CFormSummary_STI.vue?vue&type=template&id=0b1b1072&scoped=true&"
import script from "./CFormSummary_STI.vue?vue&type=script&lang=js&"
export * from "./CFormSummary_STI.vue?vue&type=script&lang=js&"
import style0 from "./CFormSummary_STI.vue?vue&type=style&index=0&id=0b1b1072&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1b1072",
  null
  
)

export default component.exports